// Constants for orgs that have text in the queue item
export const APPLE = 'apple';
export const GOOGLE = 'google';
export const SXM = 'sxm';
